<template>
  <div class="f-shop-detail-activityRate tabs-item" id="activityRate">
    <div class="title">活动费率</div>
    <div class="content" v-if="activiceRatio.settleFeeRatios || (activiceRatio['activityCoupons'] && activiceRatio['activityCoupons'].length)">
      <div v-if="activiceRatio.settleFeeRatios">
        <div class="content-title">店铺活动费率</div>
        <div class="content-value">
          <div class="pay-type-item" v-for="(item, index) in activiceRatio.settleFeeRatios" :key="index">
            <el-row class="row">
              <el-col class="col-title" :span="6">支付方式：</el-col>
              <el-col class="col-value" :span="18">{{ item.payTypeName }}</el-col>
            </el-row>
            <el-row class="row">
              <el-col class="col-title" :span="6">活动名称：</el-col>
              <el-col class="col-value" :span="18">{{ item.name }}</el-col>
            </el-row>
            <el-row class="row">
              <el-col class="col-title" :span="6">活动费率时间：</el-col>
              <el-col class="col-value" :span="14" v-if="item.startDate && item.endDate">
                <span>{{ item.startDate ? $moment(item.startDate).format('YYYY/MM/DD HH:mm:ss') : '' }}</span>
                <span> - </span>
                <span>{{ item.endDate ? $moment(item.endDate).format('YYYY/MM/DD HH:mm:ss') : '' }}</span>
              </el-col>
              <el-col class="col-value" :span="4">费率：{{ item.ratio }}%</el-col>
            </el-row>
          </div>
        </div>
      </div>

      <div v-if="activiceRatio.activityCoupons.length">
        <div class="content-title">优惠券分摊</div>
        <div class="content-value">
          <div class="pay-type-item" v-for="item in activiceRatio.activityCoupons" :key="item.templateId">
            <el-row class="row">
              <el-col class="col-title" :span="4">优惠券：</el-col>
              <el-col class="col-value" :span="20">{{item.name}}</el-col>
            </el-row>
            <el-row class="row">
              <el-col class="col-title left" :span="5" :push="4">商场承担费用：</el-col>
              <el-col class="col-value" :span="15" :push="4">{{(item.mallCostRate * 100).toFixed(2)}}%</el-col>
            </el-row>
            <el-row class="row">
              <el-col class="col-title left" :span="5" :push="4">店铺承担费用：</el-col>
              <el-col class="col-value" :span="15" :push="4">{{(item.storeCostRate * 100).toFixed(2)}}%</el-col>
            </el-row>
          </div>
        </div>
      </div>
      <auth-button auth="finance:ratio:create" class="edit-btn">
        <div :class="storeDisable ? 'disabled custom-button' : 'custom-button'" @click="onEdit">编辑</div>
      </auth-button>
    </div>
    <div class="not-set" v-else>
      <auth-button auth="finance:ratio:create">
        <div :class="storeDisable ? 'disabled custom-button' : 'custom-button'" @click="onSet">设置活动费率</div>
      </auth-button>
      <div class="hint">还未设置活动费率（活动费率，优惠券分摊）</div>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getCouponApportionData } from '@/api/finance'

export default {
  name: "fsDetailActivityRate",
  components: {
    AuthButton
  },
  props: {
    activiceRatio: {
      type: Object,
      default() {
        return {}
      }
    },
    storeDisable: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      test: false,
    };
  },
  created() {
  },
  mounted() {
    this.$emit('initPage')
  },
  updated() {
  },
  methods: {
    // 点击设置租务费率
    onSet() {
      if (this.storeDisable) {
        this.$baseMessage('「已关店」不支持设置活动费率', 'warning')
        return
      }
      this.gotoEdit()
    },

    // 点击编辑
    onEdit() {
      if (this.storeDisable) {
        this.$baseMessage('「已关店」不支持编辑', 'warning')
        return
      }
      this.gotoEdit()
    },

    // 跳转到编辑费率页
    gotoEdit() {
      this.$router.push(`/financeShop/index/setRate?id=${this.$route.query.id}`)
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.f-shop-detail-activityRate {
  min-height: 300px;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 4px;

  .content {
    position: relative;
    .content-title {
      color: #333;
      font-size: 16px;
      font-weight: 500;
    }

    .content-value {
      width: 600px;
      background: #f2f3f5;
      padding: 20px;
      margin: 20px 0;
    }

    .edit-btn {
      position: absolute;
      right: 0px;
      bottom: 0px;
    }
  }

  .custom-button {
    min-width: 110px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border-radius: 2px;
    background: #05C8AF;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #05C8AF;
    cursor: pointer;

    &:hover {
      background: #37d3bf;
      border: 1px solid #37d3bf;
    }

    &.disabled {
      background: #82e4d7;
      border: 1px solid #82e4d7;
      cursor: not-allowed;
    }
  }

  .not-set {
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .hint {
      font-size: 12px;
      color: #999999;
      margin-top: 10px;
      margin-bottom: 55px;
    }
  }

  .row {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #666666;

    .col-title {
      text-align: right;

      &.left {
        text-align: left;
      }
    }

    .col-value {
      color: #333333;
      font-weight: 500;
    }
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    margin-left: 20px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: -15px;
      content: "";
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05c8af;
    }
  }
}
</style>
